import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FieldScopeInfo_Account_Fragment = { __typename?: 'Account', id: string };

export type FieldScopeInfo_Project_Fragment = { __typename?: 'Project', id: string, name: string, imageUrl?: string | null, workspaceId: string };

export type FieldScopeInfo_Workspace_Fragment = { __typename?: 'Workspace', id: string, name: string, imageUrl?: string | null };

export type FieldScopeInfoFragment = FieldScopeInfo_Account_Fragment | FieldScopeInfo_Project_Fragment | FieldScopeInfo_Workspace_Fragment;

export const FieldScopeInfo = /*#__PURE__*/ gql`
    fragment FieldScopeInfo on FieldDefinitionScope {
  ... on Account {
    id
  }
  ... on Workspace {
    id
    name
    imageUrl
  }
  ... on Project {
    id
    name
    imageUrl
    workspaceId
  }
}
    ` as unknown as DocumentNode<FieldScopeInfoFragment, unknown>;

        

        
export const useFieldScopeInfoFragment = (
  input: string | Omit<UseFragmentOptions<FieldScopeInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FieldDefinitionScope' } };
    return input;
  })();

  return useFragment<FieldScopeInfoFragment>({
    fragment: FieldScopeInfo,
    fragmentName: 'FieldScopeInfo',
    ...options,
  });
};
  
        